<script setup>
import { ref, onMounted, nextTick, computed, watch } from "vue";
import { useSettingsStore } from "@/stores/storeSettings";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useRequestsStore } from "@/stores/storeRequests";
import { useQuestionnairesStore } from "@/stores/storeQuestionnaires";
import { useRoute } from "vue-router";
import { useModals } from "@/utils/useModals";
import FormAvitoWelcomeScreen from "@/components/questionnaire/FormAvitoWelcomeScreen.vue";
import FormQuestionnaire from "@/components/questionnaire/FormQuestionnaire.vue";

const storeSettings = useSettingsStore();
const storeField = useFieldsStore();
const storeRequests = useRequestsStore();
const storeQuestionnaires = useQuestionnairesStore();
const route = useRoute();
const { openModal } = useModals();

const questionnaires = {
	'cash-prize': {
		numbers: true,
		address: false,
		passport: true,
	},
	'tax-free-cash-prize': {
		numbers: true,
		address: false,
		passport: false,
	},
	'physical-prize': {
		numbers: false,
		address: true,
		passport: true,
	},
	'tax-free-physical-prize': {
		numbers: false,
		address: true,
		passport: false,
	},
}

const currentForm = computed(() => questionnaires[storeQuestionnaires.questionnaireType]);


const isQuestionnaireFormShow = ref(false);

const questionnaireFormShow = () => isQuestionnaireFormShow.value = !isQuestionnaireFormShow.value;
// storeQuestionnaires.isShowScreenEnd  !isQuestionnaireFormShow   
</script>
<template>
	<section class="questionnaire-section">
		<TransitionGroup>
			<FormAvitoWelcomeScreen v-if="!isQuestionnaireFormShow" @questionnaire-form-show="questionnaireFormShow">Введите номер телефона, привязанный к аккаунту Авито</FormAvitoWelcomeScreen>
			<template v-if="isQuestionnaireFormShow && !storeQuestionnaires.isShowScreenEnd">
				<FormQuestionnaire :current-form="currentForm" @questionnaire-form-show="questionnaireFormShow"/>
			</template>
			<div v-if="storeQuestionnaires.isShowScreenEnd" class="questionnaire-end">
				<div class="container">
					<div class="questionnaire-end__contaienr">
						<div class="questionnaire-end__header">
							<h2 class="questionnaire-end__title title">Готово! 😎</h2>
							<p class="questionnaire-end__text">Вы заполнили анкету — теперь остаётся ждать заслуженный приз</p>
						</div>
						<button class="btn" @click="questionnaireFormShow(), storeQuestionnaires.isShowScreenEnd = false">Закрыть</button>
					</div>
				</div>
			</div>
		</TransitionGroup>
	</section>
</template>
<style lang="scss" scoped>
@use '@/assets/scss/base/vars';

.questionnaire-section {
	padding: 4.8rem 0;
	min-height: 100%;
	display: flex;
	flex-direction: column;
	background: var(--native-bg-color);
}


.questionnaire-end {
	display: grid;
	place-content: center;
	min-height: 100%;
	flex: 1 1 auto;
}
.questionnaire-end__contaienr {
	display: grid;
	gap: 4rem;
}
.questionnaire-end__header{
	display: grid;
	gap: 2rem;
}
.questionnaire-end__title {
}
.questionnaire-end__text {
	text-align: center;
}

.v-enter-active,
.v-leave-active {
	transition:  0.3s linear;
}

.v-enter-from {
	opacity: 0;
	transform: translateY(100%);
}
.v-leave-to {
	opacity: 0;
	transform: translateY(-100%);
}
</style>
